import { NoFilterContent } from '../../../../ui/features/user-directory/components/NoFilterContent';
import { useContactManagementTranslation } from '../../../../ui/hooks/useContactManagementTranslation';
import { ContactManagementConfigContext } from '../../../../ui/providers';
import { maxUrlSearchLength } from '../../../../utils';
import { useDataTableUsingUrl } from '@juvare/common-data-table-ui/DataTable';
import { FiltersBar } from '@juvare/common-data-table-ui/FiltersBar';
import React from 'react';
import { useUserDirectoryColumns } from './useUserDirectoryColumns';
import { useUserDirectoryFilter } from './useUserDirectoryFilter';
import { useUserDirectoryFilterConfig } from './useUserDirectoryFilterConfig';
import { useUserDirectoryList } from './useUserDirectoryList';
export function useUserDirectoryTable({ onRowClick, rowSelectionEnabled }) {
    var _a, _b;
    const { t } = useContactManagementTranslation();
    const { userDirectoryTableCustomization } = React.useContext(ContactManagementConfigContext);
    const useResolveUserDirectoryFilter = (_a = userDirectoryTableCustomization === null || userDirectoryTableCustomization === void 0 ? void 0 : userDirectoryTableCustomization.overrideUseAccountFilter) !== null && _a !== void 0 ? _a : useUserDirectoryFilter;
    const params = {
        useDataProvider: (request) => useUserDirectoryList(request, useResolveUserDirectoryFilter),
        onRowClick,
        rowSelectionEnabled,
        defaultSortColumnKey: 'lastName',
        maxUrlSearchLength,
    };
    const { dataTableProps, filtersBarProps, appliedFilterData, clearActiveRow, reload, setSelectedRowIds, setActiveRowId } = useDataTableUsingUrl(params);
    const columns = useUserDirectoryColumns();
    const filterConfig = useUserDirectoryFilterConfig({
        extendFilters: userDirectoryTableCustomization === null || userDirectoryTableCustomization === void 0 ? void 0 : userDirectoryTableCustomization.extendFilters,
    });
    const defaultDataTableProps = Object.assign(Object.assign({}, dataTableProps), { title: t('panels.userDirectory.title'), columns: columns, filtersBar: React.createElement(FiltersBar, Object.assign({}, filtersBarProps, { config: filterConfig })), tableSx: { tableLayout: 'fixed' }, customTableContentComponent: ((_b = dataTableProps.customBackendResponseData) === null || _b === void 0 ? void 0 : _b.error)
            ? () => React.createElement(NoFilterContent, Object.assign({}, dataTableProps))
            : undefined });
    return {
        dataTableProps: (userDirectoryTableCustomization === null || userDirectoryTableCustomization === void 0 ? void 0 : userDirectoryTableCustomization.getDataTableProps)
            ? userDirectoryTableCustomization === null || userDirectoryTableCustomization === void 0 ? void 0 : userDirectoryTableCustomization.getDataTableProps(defaultDataTableProps, appliedFilterData)
            : defaultDataTableProps,
        filtersBarProps: filtersBarProps,
        appliedFilterData: appliedFilterData,
        clearActiveRow: clearActiveRow,
        setActiveRowId: setActiveRowId,
        setSelectedRowIds: setSelectedRowIds,
        reload: reload,
    };
}
